import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GridModule } from '@progress/kendo-angular-grid';
import { QaEmailVerificationComponent } from './qa-email-verification.component';
import { FormsModule }   from '@angular/forms';
import { AlertModule } from '../../../../common/component/alert/alert.module';
import { ModalModule } from '../../../../common/component/modal/modal.module';

@NgModule({
  declarations: [QaEmailVerificationComponent],
  imports: [
    CommonModule
    ,GridModule
    ,FormsModule
    ,AlertModule
    ,ModalModule
  ],
  exports: [QaEmailVerificationComponent]
})
export class QaEmailVerificationModule { }
